import React from "react";

const ScanTypeCard = ({ tool, isSelected, onToggle, notConfigured }) => {
  const isActive = tool.active === true;

  return (
    <div className={`scan-type-card ${isSelected ? "selected" : ""}`}>
      <div className="card-header">
        <input
          type="checkbox"
          checked={isSelected}
          onChange={() => onToggle(tool.id)}
          aria-label={`Select ${tool.name}`}
        />
        <h3>{tool.name}</h3>
      </div>
      
      <div className="card-badges">
        <span className="category-badge">{tool.category}</span>
        {isActive && <span className="active-badge">Active Scan</span>}
        {notConfigured && <span className="setup-badge">Setup Required</span>}
      </div>

      <p className="card-description">{tool.description}</p>

      {isActive && (
        <div className="active-warning">
          ⚠️ This tool actively probes and sends requests. Use only on targets you own or have explicit written authorization to test.
        </div>
      )}

      {notConfigured && (
        <div className="setup-note">
          ℹ️ The backing binary is not installed on the server. This tool will report as "not configured" when the job runs.
        </div>
      )}
    </div>
  );
};

export default ScanTypeCard;
